export * from './lib/order-contact/order-contact.component';
